import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppFloat from './WhatsAppFloat';
import './Layout.css';

export default function Layout() {
  return (
    <div className="layout">
      <a href="#main-content" className="skip-link">
        İçeriğe geç
      </a>
      <Navbar />
      <div id="main-content" className="layout__main" tabIndex={-1}>
        <Outlet />
      </div>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
